import { render } from "./provision.vue?vue&type=template&id=d1f44e84&scoped=true"
import script from "./provision.vue?vue&type=script&lang=js"
export * from "./provision.vue?vue&type=script&lang=js"

import "./provision.vue?vue&type=style&index=0&id=d1f44e84&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1f44e84"]])

export default __exports__